export function errorResolver(error: any) {
  if (error instanceof Error) {
    return error.message;
  } else if (error instanceof String) {
    return error as string;
  } else {
    console.error(error);
    return "Unable to deserialize error message, check console for the full error";
  }
}
